export default {
    GET_CAMPAIGNS_SUCCESS(state, payload) {
        state.list = payload
    },
    GET_CAMPAIGNS_FAILURE(state) {
        state.list = []
    },
    GET_STATUSES_SUCCESS(state, payload) {
        state.statuses = payload
    },
    GET_PRODUCT_TEMPLATES_SUCCESS(state, payload) {
        state.productTemplates = payload
    },
}
